import { useTranslation } from 'react-i18next'

import styled from 'styled-components'

import { baseColors, Text } from '@fairhq/common'
import { useAuthContext } from 'auth/context/useAuthContext'
import { useSignOut } from 'hooks/useSignOut'

import { Gear } from './assets/icons/Gear'
import { Help } from './assets/icons/Help'
import { Home } from './assets/icons/Home'

const StyledButton = styled.button`
  display: flex;
  width: 100%;
  border-radius: 0;
  background-color: inherit;
  border: none;
  justify-content: left;
  align-items: center;
  padding: 8px;
  color: ${baseColors.contentInverseContent};
  gap: 8px;
  &:hover,
  &:active,
  &:focus {
    color: ${baseColors.contentInverseContent};
    background-color: ${baseColors.statesHoverBackground};
    outline: none;
  }
`

const StyledAnchor = styled.a`
  display: flex;
  width: 100%;
  border-radius: 0;
  background-color: inherit;
  border: none;
  justify-content: left;
  align-items: center;
  padding: 8px;
  color: ${baseColors.contentInverseContent};
  gap: 8px;
  &:hover,
  &:active,
  &:focus {
    color: ${baseColors.contentInverseContent};
    background-color: ${baseColors.statesHoverBackground};
    text-decoration: none;
  }
`

const Container = styled.div`
  padding: 15px 0;
  flex-basis: 100%;
  align-self: flex-end;

  svg {
    flex-shrink: 0;
  }
`

export const BottomMenu = () => {
  const signOut = useSignOut()
  const { t } = useTranslation()
  const { charlieUser } = useAuthContext()

  return (
    <Container>
      <StyledAnchor href={t(`help.link`)}>
        <Help />
        <Text element="span" size="xs" fontWeight={400} type="body">
          Help
        </Text>
      </StyledAnchor>
      <StyledAnchor
        href={
          `https://${charlieUser?.companyDomain}` || `https://www.charliehr.com`
        }
      >
        <Home />
        <Text element="span" size="xs" fontWeight={400} type="body">
          Back to Charlie
        </Text>
      </StyledAnchor>
      <StyledButton onClick={signOut}>
        <Gear />
        <Text element="span" size="xs" fontWeight={400} type="body">
          {t('nav.signOut')}
        </Text>
      </StyledButton>
    </Container>
  )
}
